const Registration = () => import('./Registration')
const Blocked = () => import('./Blocked')

export default function Components(Vue) {
  Vue.component('warranty-blocked', Blocked)
  Vue.component('warranty-registration', Registration)
}
